<template>
  <div class="paperEdit-container">
    <!-- 操作栏 -->
    <div class="paperEdit-toolBar" :class="scrollFlag ? 'fixTop' : ''">
      <div class="paperEdit-toolBar-main">
        <ul>
          <li @click="showSortDialog">试题排序</li>
          <li @click="showScoreSetDialog">设置得分</li>
          <li @click="showCountDialog">试卷分析</li>
          <li @click="showPaperStructures" class="paper-struct">
            <el-popover v-model="visible" placement="bottom" trigger="click" popper-class="paper-dropdown">
              <span slot="reference" @click="visible = !visible">试卷结构</span>
              <ul>
                <li :class="paperPackages.template == item.value ? 'selected' : ''" v-for="item in paperTemplet" :key="item.value" @click="selectCheckBox(item.value)">{{ item.label }}</li>
              </ul>
              <template v-if="paperPackages">
                <el-checkbox-group v-model="paperPackages.paper_structure">
                  <el-checkbox v-for="item in paperTempletOption" :label="item.value" :key="item.value">{{ item.label }} </el-checkbox>
                </el-checkbox-group>
              </template>
            </el-popover>
          </li>
          <li @click="keepSelectExercise">继续选题</li>
        </ul>
        <transition name="fadeIn">
          <div class="had-save-tips" v-if="saveFlag">{{ saveTips }}</div>
        </transition>
        <div class="paperEdit-download-btn">
          <el-button type="primary" @click="completedPaper">完成组卷</el-button>
        </div>
      </div>
    </div>

    <!-- 操作栏弹窗 -->
    <paper-edit-dialog ref="paperEditDialog" :paperId="paperId" :sort.sync="sort" :sortExerciseData="sortExerciseData" :scoreSet.sync="scoreSet" :scoreSetData="scoreSetData" @reloadPaper="reloadPaper" :scoreCount.sync="scoreCount" :deleteExercise.sync="deleteExercise" :questionListData="questionListData" :question_id="question_id" :paperTitle="paperInfo.title"> </paper-edit-dialog>

    <!-- 换题弹窗 -->
    <question-change :paperId="paperId" @reloadPaper="reloadPaper" ref="questionChange"></question-change>

    <!-- 试卷结构 -->
    <div class="paperEdit-main-wrap">
      <!-- 主体 -->
      <div class="paperEdit-main-body">
        <div class="paperEdit-main-list">
          <!-- 左边 密封线 -->
          <div class="paperEdit-main-list-left" :class="paperPackages && paperPackages.paper_structure.includes('1') ? '' : 'hide-line-border'"></div>
          <!-- 中间主体内容 -->
          <div class="paperEdit-main-list-center" :class="paperPackages && paperPackages.paper_structure.includes('1') ? '' : 'hide-line-border'">
            <template v-if="questionListData.length > 0">
              <!-- 试卷头 -->
              <div class="paperEdit-main-list-center-hd">
                <div class="paperEdit-main-title">
                  <h1>
                    <span @click="titleEdit = false" v-show="titleEdit" class="hover-span">{{ paperInfo.title }}</span>
                    <el-input v-model="paperInfo.title" size="medium" class="editableInput" :maxlength="60" v-show="!titleEdit" @blur="resetEditable(1)" @keyup.enter.native="resetEditable(1)" v-focus></el-input>
                  </h1>
                  <h2 :class="paperPackages && paperPackages.paper_structure.includes('4') ? '' : 'hide-paper-div'">
                    <span @click="subTitleEdit = false" v-show="subTitleEdit" class="hover-span">{{ paperPackages.subtitle }}</span>
                    <el-input v-model="paperPackages.subtitle" size="small" class="editableInput" :maxlength="60" v-show="!subTitleEdit" @blur="resetEditable(2)" @keyup.enter.native="resetEditable(2)" v-focus></el-input>
                  </h2>
                </div>
                <div class="paperEdit-main-time" :class="paperPackages && paperPackages.paper_structure.includes('2') ? '' : 'hide-paper-div'">
                  <p>
                    考试时间：<span @click="examTimeEdit = false" v-show="examTimeEdit" class="hover-span">{{ paperPackages.exam_time }}</span> <el-input v-model="paperPackages.exam_time" size="mini" class="editableInput" :maxlength="4" v-show="!examTimeEdit" @blur="resetEditable(3)" @keyup.enter.native="resetEditable(3)" v-focus></el-input>分钟
                  </p>
                  <p>
                    满分：<span @click="examScores = false" v-show="examScores" class="hover-span">{{ paperPackages.score_total }}</span> <el-input v-model="paperPackages.score_total" size="mini" class="editableInput" :maxlength="4" v-show="!examScores" @blur="resetEditable(4)" @keyup.enter.native="resetEditable(4)" v-focus></el-input>分
                  </p>
                </div>
                <ul class="paperEdit-main-stuInfo" :class="paperPackages && paperPackages.paper_structure.includes('7') ? '' : 'hide-paper-div'">
                  <li>姓名：<span>____________</span></li>
                  <li>班级：<span>____________</span></li>
                  <li>学号：<span>____________</span></li>
                </ul>
                <div class="paperEdit-main-marktable" :class="paperPackages && paperPackages.paper_structure.includes('8') ? '' : 'hide-paper-div'">
                  <table>
                    <tbody>
                      <tr>
                        <th>题号</th>
                        <th v-for="item in questionListData" :key="item.id">{{ item.index }}</th>
                      </tr>
                      <tr>
                        <th>评分</th>
                        <td v-for="item in questionListData" :key="item.id"></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="paperEdit-main-notic" :class="paperPackages && paperPackages.paper_structure.includes('5') ? '' : 'hide-paper-div'">
                  <p>注意事项：</p>
                  <div @click="attentionItems = false" v-show="attentionItems" class="hover-span" v-html="paperPackages.attentions"></div>
                  <el-input type="textarea" v-model="paperPackages.attentions" :autosize="{ minRows: 4, maxRows: 6 }" class="editableInput scrollbar" :maxlength="300" v-show="!attentionItems" @blur="resetEditable(5)" @focus="paperPackages.attentions = paperPackages.attentions.replace(/<br\s*\/?>/gi, '\r\n').replace(/&nbsp;/g, ' ')" v-focus></el-input>
                </div>
              </div>
              <!-- 试卷体 -->
              <div class="paperEdit-main-list-center-bd">
                <!-- 卷I -->
                <div class="paperEdit-main-bd-part">
                  <div class="paperEdit-main-bd-title" :class="paperPackages && paperPackages.paper_structure.includes('6') ? '' : 'hide-paper-div'">
                    <h2>
                      <span @click="volume_I_edit = false" v-show="volume_I_edit" class="hover-span">{{ paperPackages.volume && paperPackages.volume[0] }}</span>
                      <el-input v-if="paperPackages.volume" v-model="paperPackages.volume[0]" size="small" class="editableInput" :maxlength="30" v-show="!volume_I_edit" @blur="resetEditable(6)" @keyup.enter.native="resetEditable(6)" v-focus></el-input>
                    </h2>
                  </div>
                  <div class="paperEdit-main-bd-section" v-for="item in exerciseDataI" :key="item.id">
                    <div class="paperEdit-main-bd-type" :class="paperPackages && paperPackages.paper_structure.includes('9') ? '' : 'hide-paper-div'">
                      <table :class="paperPackages && paperPackages.paper_structure.includes('3') ? '' : 'hide-paper-div'">
                        <tbody>
                          <tr>
                            <th>阅卷人</th>
                            <td></td>
                          </tr>
                          <tr>
                            <th>得分</th>
                            <td></td>
                          </tr>
                        </tbody>
                      </table>
                      <h3>
                        <span class="order">{{ item.index }}</span
                        ><span>、</span>
                        <span @click="item.questionTypeEdit = false" v-show="item.questionTypeEdit" class="hover-span">{{ item.type_name }}</span>
                        <el-input v-model="item.type_name" size="small" class="editableInput" :maxlength="20" v-show="!item.questionTypeEdit" @blur="resetEditable(8, item.type_id)" @keyup.enter.native="resetEditable(8, item.type_id)" v-focus></el-input>
                        <span
                          >(共<b>{{ item.num }}</b
                          >题，共<b>{{ item.score }}</b
                          >分)</span
                        >
                      </h3>
                    </div>
                    <!-- 试题列表 -->
                    <paper-edit-question :questionListData="questionListData" :exercise="item" @remove="remove" @changeQuestion="changeQuestion" @triggerSavePaper="triggerSavePaper"></paper-edit-question>
                  </div>
                </div>
                <!-- 卷II -->
                <div class="paperEdit-main-bd-part">
                  <div class="paperEdit-main-bd-title" :class="paperPackages && paperPackages.paper_structure.includes('6') ? '' : 'hide-paper-div'">
                    <h2>
                      <span @click="volume_II_edit = false" v-show="volume_II_edit" class="hover-span">{{ paperPackages.volume && paperPackages.volume[1] }}</span>
                      <el-input v-if="paperPackages.volume" v-model="paperPackages.volume[1]" size="small" class="editableInput" :maxlength="30" v-show="!volume_II_edit" @blur="resetEditable(7)" @keyup.enter.native="resetEditable(7)" v-focus></el-input>
                    </h2>
                  </div>
                  <div class="paperEdit-main-bd-section" v-for="item in exerciseDataII" :key="item.id">
                    <div class="paperEdit-main-bd-type" :class="paperPackages && paperPackages.paper_structure.includes('9') ? '' : 'hide-paper-div'">
                      <table :class="paperPackages && paperPackages.paper_structure.includes('3') ? '' : 'hide-paper-div'">
                        <tbody>
                          <tr>
                            <th>阅卷人</th>
                            <td></td>
                          </tr>
                          <tr>
                            <th>得分</th>
                            <td></td>
                          </tr>
                        </tbody>
                      </table>
                      <h3>
                        <span class="order">{{ item.index }}</span
                        ><span>、</span>
                        <span @click="item.questionTypeEdit = false" v-show="item.questionTypeEdit" class="hover-span">{{ item.type_name }}</span>
                        <el-input v-model="item.type_name" size="small" class="editableInput" :maxlength="20" v-show="!item.questionTypeEdit" @blur="resetEditable(8, item.type_id)" v-focus @keyup.enter.native="resetEditable(8, item.type_id)"></el-input>
                        <span
                          >(共<b>{{ item.num }}</b
                          >题，共<b>{{ item.score }}</b
                          >分)</span
                        >
                      </h3>
                    </div>
                    <!-- 试题列表 -->
                    <paper-edit-question :questionListData="questionListData" :exercise="item" @remove="remove" @changeQuestion="changeQuestion" @triggerSavePaper="triggerSavePaper"></paper-edit-question>
                  </div>
                </div>
              </div>
            </template>
            <div v-else class="questions-loading">
              <i class="el-icon-loading large-loading"></i>
            </div>
          </div>
          <!-- 右边留白 -->
          <div class="paperEdit-main-list-right"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var that
import Cookies from 'js-cookie'
import paperEditDialog from '@/components/paperEditDialog.vue'
import questionChange from '@/components/questionChange.vue'
import paperEditQuestion from '@/components/paperEditQuestion.vue'
import { mapGetters } from 'vuex'
import * as util from '../utils/util.js'
import validate from '../utils/validate.js'
import { paperList, savePaperStructures, savePaperContent } from '@/api/paperEdit'
export default {
  name: 'paperEdit',
  data() {
    return {
      scrollTop: 0,
      scrollFlag: false,
      // 试卷结构
      visible: false,
      paperTemplet: [
        // 试卷模板
        {
          label: '考试模板',
          value: '1',
        },
        {
          label: '测试模板',
          value: '2',
        },
        {
          label: '作业模板',
          value: '3',
        },
      ],
      paperTempletOption: [
        {
          label: '密封线',
          value: '1',
        },
        {
          label: '考试时间',
          value: '2',
        },
        {
          label: '大题评分区',
          value: '3',
        },
        {
          label: '副标题',
          value: '4',
        },
        {
          label: '注意事项',
          value: '5',
        },
        {
          label: '分卷',
          value: '6',
        },
        {
          label: '总评分',
          value: '8',
        },
        {
          label: '考生填写',
          value: '7',
        },
        {
          label: '分大题',
          value: '9',
        },
      ],
      // 试卷排序
      sort: false,
      sortExerciseData: [],
      // 设置得分
      scoreSet: false,
      scoreSetData: [], // 设置得分列表
      question_id: '',
      // 试卷统计
      scoreCount: false,
      // 删除试题
      deleteExercise: false,

      // 可输入编辑
      titleEdit: true,
      subTitleEdit: true,
      examTimeEdit: true,
      examScores: true,
      attentionItems: true,
      volume_I_edit: true,
      volume_II_edit: true,

      saveTips: '保存中...', // 保存提示
      saveFlag: false, // 保存提示

      // 试卷试题
      paperId: '', // 试卷id
      paperInfo: '',
      paperPackages: '',
      questionListData: [], // 试卷总试题
      exerciseDataI: [], // 卷I
      exerciseDataII: [], // 卷II
      optsParentWidth: '', // 选项父容器的宽度
    }
  },
  components: {
    paperEditDialog,
    questionChange,
    paperEditQuestion,
  },
  created() {
    that = this
    if (that.$route.query.paperId) {
      that.paperId = that.$route.query.paperId
    }
  },
  beforeRouteEnter(to, from, next) {
    // 每次进入路由都执行一次
    next(vm => {
      vm.$nextTick(() => {
        util.scrollTop(that.headerHeight, 500) // 滚动到指定位置140
        that.getPaperList() // 获取试卷列表
      })
    })
  },
  watch: {
    questionListData: {
      // 检测数组变化随时分组，只需操作总的数组
      handler: function(newValue, oldValue) {
        that.exerciseDataI = newValue.filter(item => {
          // 分类I
          return item.label == 0
        })
        that.exerciseDataII = newValue.filter(item => {
          // 分类II
          return item.label == 1
        })
      },
      deep: true,
    },
    paper_structure(newValue, oldValue) {
      if (oldValue != newValue) {
        that.savePaperHeader()
      }
    },
  },
  computed: {
    ...mapGetters(['headerHeight']),
    paper_structure() {
      return this.paperPackages.paper_structure
    },
  },
  mounted() {
    window.addEventListener('scroll', that.scrollToTop) // 监听滚动事件
    that.$nextTick(() => {
      that.optsParentWidth = document.querySelector('.paperEdit-main-list-center').offsetWidth - 90 // 90是padding
    })
  },
  methods: {
    scrollToTop() {
      // 监听滚动距离
      that.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      that.scrollTop > that.headerHeight ? (that.scrollFlag = true) : (that.scrollFlag = false)
    },
    // 显示试卷结构下拉
    showPaperStructures() {
      that.visible = !that.visible
    },
    selectCheckBox(val) {
      // 试卷结构
      that.paperPackages.template = val
      if (val == '1') {
        that.paperPackages.paper_structure = ['1', '2', '3', '4', '5', '6', '7', '8', '9']
      } else if (val == '2') {
        that.paperPackages.paper_structure = ['7', '9', '3', '5', '8']
      } else {
        that.paperPackages.paper_structure = ['9']
      }
    },
    completedPaper() {
      // 完成组卷
      that.$refs.paperEditDialog.calcAllExerciseScore()
      that.$refs.paperEditDialog.showDiffdialog(that.paperPackages.template)
    },
    reloadPaper(payload) {
      // 刷新试卷
      if (payload) {
        that.getPaperList()
      }
    },
    resetEditable(type, type_id) {
      // 重置可编辑参数
      switch (type) {
        case 1:
          that.titleEdit = true
          if (!that.paperInfo.title) {
            that.paperInfo.title = that.paperInfo.ctitle
          }
          if (that.paperInfo.title != that.paperInfo.ctitle) {
            that.paperInfo.ctitle = that.paperInfo.title
            that.savePaperBody()
          }
          break
        case 2:
          that.subTitleEdit = true
          if (!that.paperPackages.subtitle) {
            that.paperPackages.subtitle = that.paperPackages.csubtitle
          }
          if (that.paperPackages.subtitle != that.paperPackages.csubtitle) {
            that.paperPackages.csubtitle = that.paperPackages.subtitle
            that.savePaperHeader()
          }
          break
        case 3:
          that.examTimeEdit = true
          let regx1 = /^\d+$/.test(Number(that.paperPackages.exam_time))
          if (!that.paperPackages.exam_time || !regx1) {
            that.paperPackages.exam_time = that.paperPackages.cexam_time
          }
          if (that.paperPackages.exam_time != that.paperPackages.cexam_time) {
            that.paperPackages.cexam_time = that.paperPackages.exam_time
            that.savePaperHeader()
          }
          break
        case 4:
          that.examScores = true
          let regx2 = /^\d+$/.test(Number(that.paperPackages.score_total))
          if (!that.paperPackages.score_total || !regx2) {
            that.paperPackages.score_total = that.paperPackages.cscore_total
          }
          if (that.paperPackages.score_total != that.paperPackages.cscore_total) {
            that.paperPackages.cscore_total = that.paperPackages.score_total
            that.savePaperHeader()
          }
          break
        case 5:
          that.attentionItems = true
          that.paperPackages.attentions = that.paperPackages.attentions
            .replace(/\r\n/g, '<br/>')
            .replace(/\n/g, '<br/>')
            .replace(/\s/g, '&nbsp;')
          if (!that.paperPackages.attentions) {
            that.paperPackages.attentions = that.paperPackages.cattentions
          }
          if (that.paperPackages.attentions != that.paperPackages.cattentions) {
            that.paperPackages.cattentions = that.paperPackages.attentions
            that.savePaperHeader()
          }
          break
        case 6:
          that.volume_I_edit = true
          if (!that.paperPackages.volume[0]) {
            that.paperPackages.volume[0] = that.paperPackages.cvolume[0]
          }
          if (that.paperPackages.volume[0] != that.paperPackages.cvolume[0]) {
            that.paperPackages.cvolume[0] = that.paperPackages.volume[0]
            that.savePaperHeader()
          }
          break
        case 7:
          that.volume_II_edit = true
          if (!that.paperPackages.volume[1]) {
            that.paperPackages.volume[1] = that.paperPackages.cvolume[1]
          }
          if (that.paperPackages.volume[1] != that.paperPackages.cvolume[1]) {
            that.paperPackages.cvolume[1] = that.paperPackages.volume[1]
            that.savePaperHeader()
          }
          break
        default:
          let i
          that.questionListData.forEach((item, index) => {
            if (item.type_id == type_id) {
              i = index
            }
          })
          that.questionListData[i].questionTypeEdit = true
          if (!that.questionListData[i].type_name) {
            // 清空还原
            that.questionListData[i].type_name = that.questionListData[i].ctype_name
          }
          that.questionListData.forEach((item, index) => {
            // 校验重复
            if (i != index && item.type_name == that.questionListData[i].type_name) {
              util.showTips(`${that.questionListData[i].type_name}已存在`)
              that.questionListData[i].type_name = that.questionListData[i].ctype_name
            }
          })
          if (that.questionListData[i].type_name != that.questionListData[i].ctype_name) {
            // 清空还原
            that.questionListData[i].ctype_name = that.questionListData[i].type_name
            that.savePaperBody()
          }
      }
    },
    showSortDialog() {
      // 打开试题排序弹窗
      that.sort = true
    },
    showScoreSetDialog() {
      // 打开得分设置弹窗
      that.scoreSet = true
      that.$refs.paperEditDialog.calcAllExerciseScore()
    },
    showCountDialog() {
      // 打开试题统计
      that.$refs.paperEditDialog.getPaperStatisticals()
    },
    changeQuestion(id) {
      // 打开试题替换
      that.$refs.questionChange.showChangedialog(id)
    },
    remove(id) {
      // 确定删除试题
      that.question_id = id // 试题id
      that.deleteExercise = true
    },
    triggerSavePaper() {
      that.savePaperBody()
    },
    keepSelectExercise() {
      // 继续选题
      let stageId = '',
        subjectId = ''
      if (that.paperInfo.stage_id && that.paperInfo.subject_id) {
        stageId = that.paperInfo.stage_id
        subjectId = that.paperInfo.subject_id
      } else {
        let stageAndSubject = Cookies.get('filters')
        if (stageAndSubject) {
          stageAndSubject = stageAndSubject.split(',')
          stageId = stageAndSubject[0]
          subjectId = stageAndSubject[1]
        }
      }
      that.$router.push({
        path: '/paperFrontend/manual',
        query: {
          stage_id: stageId,
          subject_id: subjectId,
        },
      })
    },
    /*---------------------------------- 请求接口 ------------------------------------*/
    getPaperList() {
      // 获取试卷列表
      let data = {
        paper_id: that.paperId,
      }
      return new Promise((resolve, reject) => {
        paperList(data)
          .then(res => {
            if (res.code === 200) {
              that.questionListData = res.data.questions
              that.questionListData.forEach((item, index) => {
                that.$set(item, 'average', '') // 设置得分
                that.$set(item, 'questionTypeEdit', true) // 用于编辑大题名称
                that.$set(item, 'ctype_name', item.type_name) // 用于重置大题名称
                that.$set(item, 'index', util.numToChinese(index + 1)) // 大题类别顺序
              })
              // 设置选项宽度
              that.questionListData.forEach((item, index) => {
                item.question.forEach(async question => {
                  let w,
                    sub_w,
                    w_arr = []
                  for (let m = 0; m < question.options.length; m++) {
                    w = await util.setOptionsWidth(question.options[m], that.optsParentWidth)
                    w_arr.push(w)
                  }
                  that.$set(question, 'w_arr', w_arr)
                  //  子题选项
                  question.sub_questions.forEach(async item => {
                    if (item.options.length > 0) {
                      for (let n = 0; n < item.options.length; n++) {
                        sub_w = await util.setOptionsWidth(item.options[n], that.optsParentWidth)
                        that.$set(item, 'sub_width', sub_w)
                      }
                    }
                  })
                })
              })
              // 试卷信息
              that.paperInfo = res.data.info
              // 根据跳转过来编辑的试卷改变本地存的学段学科
              let str = that.paperInfo.stage_id + ',' + that.paperInfo.subject_id
              Cookies.set('filters', str, { expires: 7, path: '/', domain: that.$cookiesDomain })
              that.$root.Bus.$emit('reloadStageAndSubject', { st_id: that.paperInfo.stage_id, sub_id: that.paperInfo.subject_id }) // 触发更新头部学段学科，避免当前试卷和顶部学段学科不一致
              that.$set(that.paperInfo, 'ctitle', that.paperInfo.title)
              that.paperPackages = res.data.packages
              that.$set(that.paperPackages, 'csubtitle', that.paperPackages.subtitle)
              that.$set(that.paperPackages, 'cscore_total', that.paperPackages.score_total)
              that.$set(that.paperPackages, 'cexam_time', that.paperPackages.exam_time)
              that.$set(that.paperPackages, 'cattentions', that.paperPackages.attentions)
              that.$set(that.paperPackages, 'cvolume', JSON.parse(JSON.stringify(that.paperPackages.volume)))

              that.scoreSetData = JSON.parse(JSON.stringify(res.data.questions)) // 设置得分的数据
              that.sortExerciseData = res.data.questions // 试题排序的数据
            }
          })
          .catch(err => {
            if (err.code == 400 || (err.response && err.response.status == 404)) {
              setTimeout(() => {
                that.$router.push({
                  path: '/error',
                })
              }, 500)
            }
          })
      })
    },
    savePaperHeader() {
      // 保存试卷头部的试卷结构
      that.saveFlag = true
      let data = {
        paper_id: that.paperId,
        template: that.paperPackages.template,
        paper_structure: that.paperPackages.paper_structure,
        paper_size: that.paperPackages.paper_size,
        type: that.paperPackages.type,
        question_structure: that.paperPackages.question_structure,
        volume: that.paperPackages.volume,
        attentions: that.paperPackages.attentions,
        subtitle: that.paperPackages.subtitle,
        exam_time: that.paperPackages.exam_time,
        score_total: that.paperPackages.score_total,
      }
      return new Promise((resolve, reject) => {
        savePaperStructures(data)
          .then(res => {
            if (res.code === 200) {
              that.saveTips = '保存成功'
              setTimeout(() => {
                that.saveFlag = false
                that.saveTips = '保存中...'
              }, 500)
            } else {
              that.saveFlag = false
            }
          })
          .catch(err => {
            if (err.code == 400) {
              that.saveFlag = false
            }
          })
      })
    },
    savePaperBody() {
      // 保存试卷主体内容
      that.saveFlag = true
      let paperType = [],
        paperQuestion = []
      that.questionListData.forEach(item => {
        let obj = {}
        obj.id = item.id
        obj.type_id = item.type_id
        obj.name = item.type_name
        paperType.push(obj)
        item.question.forEach(item1 => {
          let obj1 = {}
          obj1.type_id = item.id
          obj1.question_id = item1.question_id
          paperQuestion.push(obj1)
        })
      })
      let data = {
        paper_id: that.paperId,
        title: that.paperInfo.title,
        type: paperType,
        question: paperQuestion,
      }
      return new Promise((resolve, reject) => {
        savePaperContent(data)
          .then(res => {
            if (res.code === 200) {
              that.paperId = res.data.paper_id
              Cookies.set('paperId', res.data.paper_id, {
                expires: 7,
                path: '/',
                domain: that.$cookiesDomain,
              }) // 更新paper_id,为了以后试卷再编辑
              that.saveTips = '保存成功'
              that.getPaperList() // 得到返回的试卷id重新获取试题内容
              setTimeout(() => {
                that.saveFlag = false
                that.saveTips = '保存中...'
              }, 500)
            } else {
              that.saveFlag = false
            }
          })
          .catch(err => {
            that.saveFlag = false
          })
      })
    },
    saveAll() {
      // 一起保存试卷头和试卷主体
      that.savePaperHeader()
      that.savePaperBody()
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.paperEdit-container {
  width: 100%;
  height: 100%;
  border-top: 1px solid #f2f2f2;

  .fixTop {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12), 0 0 3px 0 rgba(0, 0, 0, 0.04);
  }

  .paperEdit-toolBar {
    width: 100%;
    height: 60px;
    background-color: #fff;

    .paperEdit-toolBar-main {
      width: 1200px;
      min-width: 1200px;
      height: 100%;
      margin: 0 auto;
      & > ul {
        float: left;
        height: 100%;
        & > li {
          box-sizing: border-box;
          float: left;
          height: 100%;
          padding: 0 5px;
          line-height: 60px;
          margin-right: 25px;
          font-size: 16px;
          color: #4d4d4d;
          cursor: pointer;
          position: relative;
          &:hover {
            color: #4fadff;
          }
          &.paper-struct > span {
            display: inline-block;
            width: 100%;
            height: 100%;
          }
        }
      }

      .had-save-tips {
        float: left;
        box-sizing: border-box;
        padding: 5px 18px;
        margin: 15px 0 0 60px;
        font-size: 14px;
        text-align: center;
        line-height: 20px;
        color: #2b99ff;
        background: rgba(35, 184, 255, 0.1);
        border: 1px solid #2b99ff;
        border-radius: 4px;
      }

      .paperEdit-download-btn {
        float: right;
        height: 40px;
        text-align: center;
        line-height: 40px;
        margin-top: 10px;
        & > .el-button {
          width: 120px;
          height: 100%;
        }
      }
    }
  }

  .paperEdit-main-wrap {
    overflow: hidden;
    width: 100%;
    height: 100%;

    .paperEdit-main-body {
      width: 1200px;
      height: 140px;
      min-width: 1200px;
      background-color: #fff;
      margin: 10px auto 0;
    }

    .questions-loading {
      width: 100%;
      height: 600px;
      line-height: 250px;
      text-align: center;
    }

    .paperEdit-main-body {
      margin-bottom: 62px;
      height: 100%;

      .paperEdit-main-list {
        box-sizing: border-box;
        overflow: hidden;
        width: 100%;
        height: 100%;

        & > .paperEdit-main-list-left,
        .paperEdit-main-list-right {
          float: left;
          box-sizing: border-box;
          width: 135px;
          height: 800px;
          text-align: center;
        }

        & > .paperEdit-main-list-left {
          background: url(../assets/images/line.png) no-repeat center 150px;
        }

        & > .hide-line-border {
          background: none;
        }

        & > .paperEdit-main-list-center {
          box-sizing: border-box;
          width: 930px;
          min-width: 930px;
          overflow: hidden;
          margin: 0 auto;
          padding: 20px 30px 40px;
          border-left: 1px dashed #ccc;
          float: left;
          &.hide-line-border {
            border-left: 1px dashed transparent;
          }
          .hide-paper-div {
            display: none;
          }

          .hover-span {
            padding: 3px 5px;
            box-sizing: border-box;
            outline: none;
            cursor: pointer;
            border: 1px solid transparent;

            &:hover {
              background: rgba(35, 184, 255, 0.1);
              border-color: #2b99ff;
            }
          }

          .paperEdit-main-list-center-hd {
            margin-bottom: 20px;
            & > .paperEdit-main-title {
              width: 100%;
              text-align: center;
              & > h1 {
                box-sizing: border-box;
                outline: none;
                height: 50px;
                line-height: 44px;
                color: #333;
                font-size: 20px;
                overflow: hidden;
                cursor: pointer;
                border: 1px solid transparent;
              }
              & > h2 {
                box-sizing: border-box;
                outline: none;
                height: 36px;
                line-height: 32px;
                color: #333;
                font-size: 18px;
                overflow: hidden;
                cursor: pointer;
                border: 1px solid transparent;
              }
            }

            & > .paperEdit-main-time {
              width: 100%;
              text-align: center;
              margin-top: 15px;

              & > p {
                display: inline-block;
                color: #333;
                font-size: 14px;
                height: 30px;
                margin-right: 12px;
              }
            }

            & > .paperEdit-main-stuInfo {
              margin-top: 15px;
              overflow: hidden;
              height: 20px;
              line-height: 20px;
              text-align: center;

              & > li {
                display: inline-block;
                color: #333;
                font-size: 14px;
                overflow: hidden;

                & > span {
                  color: #333;
                }
              }
            }

            & > .paperEdit-main-marktable {
              margin: 25px 0 15px;
              padding: 0 80px;

              & > table {
                width: 100%;
                color: #333;
                font-size: 14px;
                text-align: center;

                td,
                th {
                  height: 40px;
                  line-height: 40px;
                  border: 1px solid #ccc;
                }
              }
            }

            & > .paperEdit-main-notic {
              margin-bottom: 15px;

              & > p {
                margin: 15px 0 5px 0;
                font-size: 14px;
                color: #333;
              }

              & > .hover-span {
                color: #333;
                padding: 0;
                line-height: 22px;
                font-size: 14px;
              }
            }
          }

          .paperEdit-main-list-center-bd {
            // overflow: hidden;
            .paperEdit-main-bd-part {
              & + .paperEdit-main-bd-part {
                margin-top: 20px;
              }
              .paperEdit-main-bd-title {
                text-align: center;
                margin-bottom: 10px;

                & > h2 {
                  height: 36px;
                  line-height: 34px;
                  margin-top: 16px;
                }
              }

              .paperEdit-main-bd-section {
                & > .paperEdit-main-bd-type {
                  & > table {
                    float: left;
                    margin: 8px;
                    width: 100px;
                    background: #fff;
                    font-size: 12px;
                    color: #333;
                    text-align: center;

                    tr,
                    th {
                      width: 50%;
                      height: 30px;
                      line-height: 30px;
                      border: 1px solid #ccc;
                    }
                  }

                  h3 {
                    line-height: 80px;
                    font-size: 14px;
                    & > * {
                      margin: 0;
                      padding: 0;
                    }
                  }

                  .hover-span {
                    padding: 3px;

                    & + .editableInput {
                      width: auto;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
body .paper-dropdown {
  position: absolute;
  top: 55px;
  left: -112px;
  z-index: 99999;
  width: 300px;
  background-color: #fff;
  border: 1px solid #2b99ff;
  box-sizing: border-box;
  padding: 20px;
  border-radius: 0;
  margin-top: 10px !important;
  & > ul {
    width: 100%;
    overflow: hidden;
    padding-bottom: 10px;
    border-bottom: 1px solid #f2f2f2;
    & > li {
      cursor: pointer;
      float: left;
      width: 78px;
      height: 30px;
      line-height: 30px;
      background-color: #f2f2f2;
      color: #333;
      text-align: center;
      font-size: 13px;
      &:nth-child(2) {
        margin: 0 12px;
      }
      &.selected {
        background-color: #2b99ff;
        color: #fff;
      }
    }
  }
  & > .el-checkbox-group {
    line-height: 20px;
    overflow: hidden;
    .el-checkbox {
      float: left;
      margin: 15px 15px 0 0;
      &:nth-child(3n) {
        margin-right: 0;
      }
      .el-checkbox__label {
        padding-left: 5px;
      }
    }
  }
  &.el-popper .popper__arrow {
    border-bottom-color: #07a6f1;
    border-width: 8px;
    top: -16px;
    &::after {
      border-width: 8px;
      top: -7px;
      margin-left: -8px;
    }
  }
}
</style>
